import Styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from '../../assets/icons/info.svg';

const TooltipText = Styled.div`
    position:absolute;
    top:${props => props.size + 2}px;
    left:-88px;
    max-width: 200px;
    background:white;
    color:#7B8A96;
    visibility: hidden;
    z-index:100;
    padding:8px;
    font-size:12px;
    line-height:12px;
    font-weight: normal;
    width: max-content;
    border: 1px solid #E5E8EA;
    border-radius: 4px;
`;

const TooltipContainer = Styled.div`
  position: relative;
  display: flex;
  align-items:center;
  justify-content:cente;
  width:${props => props.size}px;
  height:${props => props.size}px;
  margin:0 4px;
  &:hover > ${TooltipText} {
    visibility: visible;
  }
`;

const Tooltip = ({ size, text, ...rest }) => (
  <TooltipContainer size={size} {...rest}>
    <InfoIcon width={size} height={size} />
    <TooltipText size={size}>{text}</TooltipText>
  </TooltipContainer>
);

Tooltip.propTypes = {
  size: PropTypes.number,
  text: PropTypes.string,
};

Tooltip.defaultProps = {
  size: 24,
  text: 'Text prop is missing 🤷‍',
};
export default Tooltip;
